/**
 *
 * @param {string} permission
 * @returns true - user have this permisson || else - false
 * default export
 */

import { isAdmin } from "../components/familytree/scripts/cy-core";

/* eslint-disable no-console */
const checkPermisson = (permission) => {
  let userInfo;
  let result;
  const savedUser = localStorage.getItem('userInfo');
  if (!savedUser) {
    result = false;
  } else {
    try {
      userInfo = JSON.parse(savedUser);

      if (!Array.isArray(userInfo?.permissions)) {
        result = false;
      } else {
        result = userInfo?.permissions.some(
          (item) => isAdmin() || item.split('::').includes(permission),
        );
      }
    } catch (error) {
      result = false;
    }
  }
  // // debug-console.log('check Permission: ' + permission + ', result=' + result);
  return result;
};
/**
 *
 * @param {array} permissions
 * @returns true - user have ONE OF permission in array || else - false
 */
export const checkPermissons = (permissions) => {
  // // debug-console.log('check Permissons: '+ permissions);
  if (!Array.isArray(permissions)) return false;

  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  if (!Array.isArray(userInfo?.permissions)) return false;

  const result = userInfo?.permissions.some(
    (item) => isAdmin() || permissions.some((el) => item.includes(el)),
  ); // item === '*'
  
  // // debug-console.log('check result=', result);
  return result;
};
/**
 *
 * @param {array} permissions
 * @returns true - user have ALL permission in array || else - false
 */
export const checkPermissonsExact = (permissions) => {
  // // debug-console.log('checkExact: '+ permissions);
  if (!Array.isArray(permissions)) return false;
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));
  if (!Array.isArray(userInfo?.permissions)) return false;
  // // debug-console.log(permissions.every((item) => userInfo?.permissions.some((el) => el.includes(item))));
  return permissions.every(
    (item) => isAdmin() || userInfo?.permissions.some((el) => el.includes(item)),
  );
};

export default checkPermisson;
